<template>
	<div>
		<div class="stream" v-if="$route.params.id == 1">
			<div class="wrapper">
				<div class="stream_video">
					<iframe src="https://player.twitch.tv/?channel=saddota2tv" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>
				</div>
				
				<div class="stream_title">УЛУЧШАЮ КОММУНИТИ 2800-3900 по фасту</div>
			</div>
		</div>
		<div class="stream" v-if="$route.params.id == 2">
			<div class="wrapper">
				<div class="stream_video">
					<iframe src="https://player.twitch.tv/?channel=grimmmz" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>
				</div>
				
				<div class="stream_title">[!title !prime] Doom Eternal - NIGHTMARE DIFFICULTY (Doom all day/night)</div>
			</div>
		</div>
		<div class="stream" v-if="$route.params.id == 3">
			<div class="wrapper">
				<div class="stream_video">
					<iframe src="https://player.twitch.tv/?channel=rasty_airsoft" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>
				</div>
				
				<div class="stream_title">Гайд по РАЗВЯЗКЕ !развязка !дикие !звук !гайды !сборки</div>
			</div>
		</div>
		<div class="stream" v-if="$route.params.id == 4">
			<div class="wrapper">
				<div class="stream_video">
					<iframe src="https://player.twitch.tv/?channel=momentsoftarkov" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>
				</div>
				
				<div class="stream_title">Что-то не так со шведами.</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {}
</script>

<style scoped>

</style>